module.exports = {
  google: {
    API_KEY: "", // Optional - only needed if using Google Maps or other Google APIs
    CLIENT_ID: "866865525923-uq5rhj3ovcupdhaofp59fue3019f5rd0.apps.googleusercontent.com",
    SECRET: "", // Not needed for client-side OAuth (only for server-side flows)
  },
  facebook: {
    APP_ID: "",
  },
}
